import { createContext } from 'react';

type DefaultValue = {
  newSearch: boolean;
};

const SearchContext = createContext<DefaultValue>({
  newSearch: false,
});

export default SearchContext;
